import React, { forwardRef } from "react" ;

const WieldyPageFooter = forwardRef((props, ref) =>
{
    const str =  new Date().getFullYear() ;

    return (
        <footer ref={ref} className="dt-footer">
            Copyright © 2021 - { str } <a target="_blank" href="https://www.arcadoptionne.org.uk/">&nbsp; ARC Adoption North East</a> - All Rights Reserved
        </footer>
    ) ;
});

export default WieldyPageFooter;
